import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Button, Row, Col } from 'react-bootstrap';

import { formStatusDispatchHelper, formReset } from 'actions/FormStatusActions';
import { addNotification } from 'actions/NotificationsActions';
import {getAuthorizationLabel, getAuthorizationType} from 'helpers/order';

import Modal from 'components/Modal';
import Data from 'components/Data';
import RichEditorContent from 'components/RichEditorContent';

import Loader from 'components/layout/Loader';
import IntlDateTime from 'components/layout/IntlDateTime';
import TimelineHeader from 'components/layout/embeddedTimeline/common/TimelineHeader';

import FormRichEditor from 'components/forms/FormRichEditor';
import {getNameInCurrentLanguage} from "helpers/intl";

class OrderAuthDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      initClose: false,
      selectedAuthRequest: null,
      selectedAction: null,
      actionMessage: '',
    };
  }

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      formStatus,
      doNotify,
    } = this.props;

    if (prevProps.formStatus.pending && !formStatus.pending && !formStatus.hasError) {
      doNotify(1, messages.authorization_data_saved);
      this.doClose();
    }
  };

  onShow = () => {
    this.setState({ selectedAuthRequest: null, selectedAction: null, actionMessage: '' });
  };

  onExit = () => {
    const { resetForm } = this.props;
    resetForm();
  };

  close = () => {
    this.setState(prevState => ({ initClose: !prevState.initClose }));
  };

  doClose = () => {
    this.setState({ initClose: false });
    const { close } = this.props;
    close();
  };

  authAction = (selectedAuthRequest, selectedAction) => {
    this.setState({ selectedAuthRequest, selectedAction });
  };

  onSubmit = e => {
    e.preventDefault();
    e.stopPropagation();

    const { order, onSubmit } = this.props;
    const { selectedAuthRequest, selectedAction, actionMessage } = this.state;

    onSubmit(order.id || order.getId(), selectedAuthRequest, { resolution: selectedAction, message: actionMessage });
  };

  getTimeline = timeline => {
    if (timeline && timeline.length) {
      return (
        <div class="timeline-container left no-margin p-b-20" style={{ width: '100%' }}>
          <section class="timeline line-grey no-margin p-b-0">
            {timeline.map(timelineEntry => {
              return (
                <div className="timeline-block" key={timelineEntry.id}>
                  <div className="timeline-point small" />
                  <div className="timeline-content">
                    <div className="card social-card share full-width">
                      <TimelineHeader publicCreator={timelineEntry.public_creator} />

                      <div className="card-description">
                        <RichEditorContent content={'<p>' + timelineEntry.message + '</p>'} />
                      </div>
                    </div>
                    <div className="event-date">
                      <small className="fs-12 hint-text">
                        <IntlDateTime date={timelineEntry.cdate} />
                      </small>
                    </div>
                  </div>
                </div>
              );
            })}
          </section>
        </div>
      );
    }
  };

  render() {
    const {
      intl: { messages },
      show,
      user,
      order,
      orderAuthorization,
      formStatus,
      pipeline
    } = this.props;
    const { initClose, selectedAuthRequest, selectedAction } = this.state;

    const isUsersOrder =
      user.username ===
      ((order.public_creator && order.public_creator.id) ||
        (order.getPublicCreator && order.getPublicCreator().getId()));

    let appIntlDe = {displayIntlForm: 'de'};

    return (
      <Modal show={show} onHide={this.close} bsSize="lg" onExit={this.onExit} onShow={this.onShow}>
        <Modal.Header closeButton>
          <Modal.Title>{messages.authorization_status}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div class={initClose ? 'hide' : ''}>
            <Data dataName="orderAuthorization" url={`/api/orders/${order.id || order.getId()}/authorizations.json`} />

            {orderAuthorization.pending ? (
              <Loader />
            ) : (
              <Row>
                {!!orderAuthorization.data.editable_count && (
                  <Col xs={12} md={6}>
                    <h3>{messages.available_actions}</h3>
                    {orderAuthorization.data.editable_authorization_list.map(authCheck => {
                      if (authCheck.type === getAuthorizationType(getNameInCurrentLanguage(pipeline?.getName?.(), appIntlDe))) {
                        return (
                          <div key={authCheck.type} className="m-b-20 b-b b-grey p-b-10">
                            <h4>{getAuthorizationLabel(authCheck.type, messages)}</h4>

                            {this.getTimeline(authCheck.timeline)}

                            {!selectedAuthRequest && (
                              <div>
                                {isUsersOrder && authCheck.are_changes_requested && (
                                  <>
                                    <Button bsStyle="info" onClick={() => this.authAction(authCheck.id, 'resolved')}>
                                      <i className="fas fa-check-circle"/> {messages.reply}
                                    </Button>
                                  </>
                                )}
                                {!isUsersOrder && (
                                  <>
                                    <Button bsStyle="success"
                                            onClick={() => this.authAction(authCheck.id, 'authorize')}>
                                      <i className="fas fa-check-circle"/> {messages.authorize}
                                    </Button>{' '}
                                    <Button bsStyle="danger" onClick={() => this.authAction(authCheck.id, 'reject')}>
                                      <i className="fas fa-times-circle"/> {messages.reject}
                                    </Button>{' '}
                                    {/* CD-311 / CD-378 */false && (
                                      <Button
                                        bsStyle="info"
                                        onClick={() => this.authAction(authCheck.id, 'request_changes')}
                                      >
                                        <i className="fas fa-reply"/> {messages.request_changes}
                                      </Button>
                                    )}
                                  </>
                                )}
                              </div>
                            )}
                            {selectedAuthRequest === authCheck.id && (
                              <>
                                <div>
                                  <Button onClick={() => this.authAction(null, null)}>
                                    <i className="fal fa-long-arrow-left"/> {messages.cancel}
                                  </Button>
                                </div>
                                <form method="put" onSubmit={this.onSubmit}>
                                  <h5>
                                    {selectedAction === 'authorize' && messages.authorize}
                                    {selectedAction === 'reject' && messages.reject}
                                    {selectedAction === 'request_changes' && messages.request_changes}
                                  </h5>
                                  <div className="form-group-attached">
                                    <FormRichEditor
                                      name="actionMessage"
                                      label={messages.message}
                                      onChange={(name, value) => this.setState({[name]: value})}
                                      disabled={formStatus.pending}
                                    />
                                  </div>
                                  <div className="m-t-15 text-right">
                                    <Button bsStyle="success" bsSize="lg" disabled={formStatus.pending} type="submit">
                                      <i
                                        class={`fa-fw m-r-10 ${
                                          formStatus.pending ? ' fa fa-circle-notch fa-spin' : 'fal fa-save'
                                        }`}
                                      />
                                      {messages.save}
                                    </Button>
                                  </div>
                                </form>
                              </>
                            )}
                          </div>
                        );
                      }
                    })}
                  </Col>
                )}

                <Col xs={12} md={orderAuthorization.data.editable_count ? 6 : 12}>
                  <h3>Historie:</h3>
                  {orderAuthorization.data.authorization_list.map(authCheck => {
                    return (
                      <div key={authCheck.type} className="m-b-20 b-b b-grey p-b-10">
                        <h4>
                          {authCheck.is_authorized && <i className="fa-fw fas fa-check-circle text-success" />}
                          {authCheck.is_rejected && <i className="fa-fw fas fa-times-circle text-danger" />}
                          {authCheck.are_changes_requested && (
                            <i className="fa-fw fas fa-exclamation-triangle text-warning" />
                          )}
                          {!authCheck.is_authorized && !authCheck.is_rejected && !authCheck.are_changes_requested && (
                            <i className="fa-fw fas fa-hourglass-start text-info" />
                          )}{' '}
                          {getAuthorizationLabel(authCheck.type, messages)}
                        </h4>

                        {this.getTimeline(authCheck.timeline)}
                      </div>
                    );
                  })}
                </Col>
              </Row>
            )}
          </div>

          {initClose && (
            <div>
              <h2 class="text-center">{messages.really_cancel}</h2>
              <p class="hint-text text-center">{messages.unsaved_information_will_be_lost}</p>
              <div class="text-center m-b-25">
                <Button
                  bsStyle="primary"
                  bsSize="lg"
                  class="m-b-20"
                  onClick={() => this.setState({ initClose: false })}
                >
                  {messages.no}
                </Button>
              </div>
              <div class="text-center">
                <Button bsStyle="danger" onClick={this.doClose}>
                  {messages.yes}
                </Button>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.login.user,
    orderAuthorization: state.data.orderAuthorization,
    formStatus: state.formStatus.orderAuthorization,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onSubmit: (orderId, authId, args) => {
      formStatusDispatchHelper(
        'orderAuthorization',
        `/api/orders/${orderId}/authorizations/${authId}.json`,
        args,
        'put',
        dispatch
      );
    },
    resetForm: () => {
      formReset('orderAuthorization');
    },
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(OrderAuthDetails)
);
